import { getAutoTieoutMapedElements } from 'api/auto-tieout-api';
import { createAction } from 'redux-actions';
import { fetchStatementSummaryElements } from '../statement-summary/elements-summary-actions';

export const autoTieoutMapedElementsLoading = createAction(
  'AUTO_TIEOUT_MAPED_ELEMENTS_LOADING',
);
export const autoTieoutMapedElementsLoaded = createAction(
  'AUTO_TIEOUT_MAPED_ELEMENTS_LOADED',
);
export const autoTieoutMapedElementsError = createAction(
  'AUTO_TIEOUT_MAPED_ELEMENTS_ERROR',
);
export const clearAutoTieoutMapedElements = createAction(
  'AUTO_TIEOUT_CLEAR_MAPED_ELEMENTS',
);
export const setTargetElementClicked = createAction(
  'AUTO_TIEOUT_TARGET_ELEMENT_CLICKED',
);
export const removeTargetElementClicked = createAction(
  'AUTO_TIEOUT_REMOVE_TARGET_ELEMENT_CLICKED',
);
export const setSourceElementClicked = createAction(
  'AUTO_TIEOUT_SOURCE_ELEMENT_CLICKED',
);
export const removeSourceElementClicked = createAction(
  'AUTO_TIEOUT_REMOVE_SOURCE_ELEMENT_CLICKED',
);

export const fetchAutoTieoutMapedElements =
  ({
    clientId,
    sourceStatementId,
    targetStatementId,
    sourceRevisionId,
    targetRevisionId,
    withoutLoading = false,
  }) =>
  async (dispatch, getState) => {
    !withoutLoading && dispatch(autoTieoutMapedElementsLoading());
    try {
      const response = await getAutoTieoutMapedElements({
        clientId,
        sourceStatementId,
        targetStatementId,
        sourceRevisionId,
        targetRevisionId,
      });
      dispatch(autoTieoutMapedElementsLoaded({ response }));
    } catch (error) {
      dispatch(autoTieoutMapedElementsError({ error }));
    }
  };
